import React from 'react';
import { useAppDispatch, useAppSelector } from '../ui/pages/store';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { v4 } from 'uuid';
import { Contact } from '../types/contact';
import { ContactContext, ContactContextProps } from '../context/ContactContext';

const contactState = {
  items: new Map<string, Contact>(),
  loading: false,
};

export const contactSlice = createSlice({
  name: 'contact',
  initialState: { key: v4() },
  reducers: {
    reset: state => {
      contactState.items = new Map();
      contactState.loading = true;
      state.key = v4();
    },
    set: (state, action: PayloadAction<Contact[]>) => {
      contactState.items = new Map();
      action.payload.forEach(p => contactState.items.set(p.id, new Contact(p)));
      state.key = v4();
    },
    add: (state, action: PayloadAction<Contact[]>) => {
      action.payload.forEach(p => contactState.items.set(p.id, new Contact(p)));
      contactState.items = new Map(contactState.items);
      state.key = v4();
    },
    delete: (state, action: PayloadAction<Contact[]>) => {
      action.payload.forEach(p => contactState.items.delete(p.id));
      contactState.items = new Map(contactState.items);
      state.key = v4();
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      contactState.loading = action.payload;
      state.key = v4();
    },
  },
});

interface ContactProviderProps {
  children: React.ReactNode;
}

export default function ContactProvider({ children }: ContactProviderProps) {
  const dispatch = useAppDispatch();
  const key = useAppSelector(state => state.contacts.key);

  const contactContext: ContactContextProps = {
    contacts: contactState.items,
    contactsLoading: contactState.loading,
    setContacts: (contacts: Map<string, Contact>) => {
      dispatch(contactSlice.actions.set([...contacts.values()]));
    },
  };

  return <ContactContext.Provider value={contactContext}>{children}</ContactContext.Provider>;
}
